import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { useTranslation } from "@flare/i18n";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { PrivacyDisclaimer } from "../components/privacy-disclaimer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { StepTitle } from "../components/step-title";
import { funnelInputsNameMap } from "../config";

import { ChoiceBoxContent } from "./components/choice-box-content";

export default function StateSelection() {
  const { t } = useTranslation();
  const { setValue } = useFormContext();

  const choices = [
    { label: t("ARIZONA"), value: "arizona" },
    {
      label: t("CALIFORNIA"),
      value: "california",
    },
    { label: t("COLORADO"), value: "colorado" },
    { label: t("FLORIDA"), value: "florida" },
    { label: t("GEORGIA"), value: "georgia" },
    { label: t("ILLINOIS"), value: "illinois" },
    { label: t("MARYLAND"), value: "maryland" },
    { label: t("MICHIGAN"), value: "michigan" },
    { label: t("NEW_YORK"), value: "new York" },
    { label: t("TEXAS"), value: "texas" },
    {
      label: t("FUNNEL_STATE_SELECTION_CHOICE_SOMEWHERE_ELSE"),
      value: "unsupported",
    },
  ];

  useEffect(() => {
    // reset values related to zip code step
    setValue(funnelInputsNameMap.county, "");
    setValue(funnelInputsNameMap.stateCode, "");
    setValue(funnelInputsNameMap.stateDisplayText, "");
    setValue(funnelInputsNameMap.zipCode, "");
    // TODO: remove if needed after direct to LSS a/b test is finished based on the test results
    setValue(funnelInputsNameMap.isAttorneyAvailable, false);
  }, [setValue]);

  return (
    <>
      <StepContainer>
        <StepContent>
          <BackButton />
          <StepTitle>{t("FUNNEL_STATE_SELECTION_TITLE")}</StepTitle>
          <ChoiceBoxContent
            name={funnelInputsNameMap.state}
            choices={choices}
            required
          />
        </StepContent>
        <ActionsContainer>
          <PrivacyDisclaimer />
          <ActionButton>{t("FUNNEL_ACTION_BUTTON_NEXT")}</ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}
